import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function DevolucionesProveedoresSinCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_DEVOLUCIONES_PROVEEDORES = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES;

  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_DEVOLUCIONES_PROVEEDORES =
    process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES_PROVEEDORES;

  const URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS =
    process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [compras, setCompras] = useState([]);
  const [selectedCompra, setSelectedCompra] = useState("");

  const [proveedor, setProveedor] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [total_general, setTotalGeneral] = useState(0);
  const [rollosTotales, setRollosTotales] = useState(0);

  const [articulosDevolucion, setArticulosDevolucion] = useState([]);
  const [fecha_compra, setFechaCompra] = useState("");
  const [total_kilos_pedido, setTotalKilosPedido] = useState(0);
  const [total_metros_pedido, setTotalMetrosPedido] = useState(0);
  const [total_general_pedido, setTotalGeneralPedido] = useState(0);

  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_COMPRAS}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCompras = res.data;
        setCompras(allCompras);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveDevolucion = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    try {
      const response = await axios.post(
        URL_DEVOLUCIONES_PROVEEDORES,
        {
          is_active: "Si",
          fecha,
          compras: selectedCompra,
          user: user.id,
          observaciones,
          total_general: total_general.toFixed(2),
          total_cantidad: parseFloat(total_metros) + parseFloat(total_kilos),
          aplicada: "No",
          proveedores: idProveedor,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const devolucionId = response.data._id;
      const allPromises = [];

      // Procesar rollos seleccionados
      articulosDevolucion.forEach((a) => {
        if (a.select) {
          if (parseFloat(a.cantidad) !== parseFloat(a.cantidadOriginal)) {
            // Devolucion parcial: el rollo se divide. La cantidad restante se
            // queda en inventario y la cantidad devuelta se da de baja al proveedor.
            const parcialPromise = axios.patch(
              `${URL_INVENTARIOS}/devolucionProveedoresParcial/${a._id}`,
              {
                devolucionesProveedores: devolucionId,
                cantidadDevuelta: a.cantidad,
                articulos: a.idArticulo,
                colores: a.color,
                clave: a.clave,
                precio: a.costo,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            allPromises.push(parcialPromise);
          } else {
            // Devolucion completa: el rollo entero se da de baja al proveedor.
            const patchPromise = axios.patch(
              `${URL_INVENTARIOS}/devolucionProveedores/${a._id}`,
              {
                devolucionesProveedores: devolucionId,
                is_active: "No",
                articulos: a.idArticulo,
                colores: a.color,
                clave: a.clave,
                precio: a.costo,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            allPromises.push(patchPromise);
          }
        }
      });

      // Pegamos a Devoluciones Proveedores Acumulado
      cantidadAgrupado.forEach((w) => {
        const acumuladoPromise = axios.post(
          `${URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS}`,
          {
            is_active: "Si",
            devolucionesProveedores: devolucionId,
            articulos: w.idArticulo,
            colores: w.color,
            cantidad: w.cantidad,
            fecha,
            proveedores: idProveedor,
            compras: selectedCompra,
            clave: w.clave,
            costo: w.costo,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        allPromises.push(acumuladoPromise);
      });

      await Promise.all(allPromises);

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Devolucion",
          detalle: `Compra ${selectedCompra}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      Swal.fire("Good job!", "Creado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data || error.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  function ActualizaTotales() {
    let seleccionados = articulosDevolucion.filter((e) => e.select);

    let mts = seleccionados.filter((e) => e.unidadArticulo == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);

    let KG = seleccionados.filter((e) => e.unidadArticulo == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let totalDin = seleccionados.map((c) => parseFloat(c.costo));
    let TDin = totalDin.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TDin);

    setRollosTotales(seleccionados.length);

    let agrupado = seleccionados.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["color"] + item["clave"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        color: item.color,
        clave: item.clave,
        cantidad: 0,
        costo: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].costo += item.costo;
      groups[val].idArticulo = item.idArticulo;
      groups[val].unidadArticulo = item.unidadArticulo;
      groups[val].color = item.color;
      groups[val].clave = item.clave;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
  }

  const handleChangeCantidad = (id, event) => {
    const value = parseFloat(event.target.value);
    setArticulosDevolucion(
      articulosDevolucion.map((data) => {
        if (data._id === id) {
          data.cantidad = value;
          data.costo = value * parseFloat(data.costoUnitario);
        }
        return data;
      })
    );
    ActualizaTotales();
  };

  function jalaCompra(e) {
    setSelectedCompra(e);

    axios
      .get(`${URL_INVENTARIOS}/comprasDevolucionSin/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosDevolucion = res.data.map((a) => ({
          ...a,
          cantidadOriginal: a.cantidad,
          select: false,
        }));
        setArticulosDevolucion(allArticulosDevolucion);
      })
      .catch((err) => {
        console.log(err);
      });

    compras.map((a) => {
      if (a._id == e) {
        setFechaCompra(a.fecha);
        setTotalKilosPedido(a.total_kilos);
        setTotalMetrosPedido(a.total_metros);
        setTotalGeneralPedido(a.total_general);
        setProveedor(a.proveedores[0].razon_social);
        setIdProveedor(a.proveedores[0]._id);
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Devolucion a Proveedor (Sin Escanear)</h3>
          <Form>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Compra</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedCompra}
                  required
                  onChange={(e) => jalaCompra(e.target.value)}
                >
                  <option value="0">Selecciona un Compra</option>
                  {compras
                    .sort((a, b) => (a.idCompras < b.idCompras ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          # {a.idCompras}{" / "}
                          {a.proveedores[0].nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Fecha Compra</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_compra}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaCompra(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Proveedor</Label>
                <Input
                  type="text"
                  placeholder="Proveedor"
                  value={proveedor}
                  required
                  disabled
                  onChange={(e) => {
                    setProveedor(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}
                  <br />
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad Original</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Clave</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Devolver</Label>
              </Col>
            </Row>

            {articulosDevolucion.map((inputField) => (
              <div key={inputField._id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idInventario"
                      type="string"
                      value={inputField._id}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulo"
                      type="string"
                      value={inputField.articulo}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="unidad"
                      type="string"
                      value={inputField.unidadArticulo}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidadOriginal"
                      type="string"
                      value={inputField.cantidadOriginal}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeCantidad(inputField._id, event)
                      }
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="clave"
                      type="string"
                      value={inputField.clave}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      type="checkbox"
                      checked={inputField.select}
                      onChange={(e) => {
                        let checked = e.target.checked;
                        setArticulosDevolucion(
                          articulosDevolucion.map((data) => {
                            if (inputField._id == data._id) {
                              data.select = checked;
                            }
                            return data;
                          })
                        );
                        ActualizaTotales();
                      }}
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
          </Form>
          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  onClick={saveDevolucion}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
              <Button
                href="/ListadoDevolucionesProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default DevolucionesProveedoresSinCreate;
